import { Component, OnInit } from '@angular/core';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';

import { MessageService } from 'primeng/api';
import { FilterCedente } from 'src/app/_models/filter/filterCedente';
import { Cedente } from 'src/app/_models/cedente/cedente';
import { CedenteService } from 'src/app/_services/cedente.service';
import { EmailSacadoService } from 'src/app/_services/emailSacado.service';
import { HistoricoEmailDisplay } from 'src/app/_models/titulo/historicoEmailDisplay';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';
import { ClickService } from 'src/app/_services/click.service';
import { HistoricoClickDisplay } from 'src/app/_models/titulo/historicoClickDisplay';


@Component({
        templateUrl: 'pesquisaclick.component.html',
        styles: [`
            :host ::ng-deep .p-dialog .product-image {
                width: 150px;
                margin: 0 auto 2rem auto;
                display: block;
            }

            @media screen and (max-width: 960px) {
                :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                    text-align: center;
                }

                :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                    display: flex;
                }
            }

        `],
        providers: [MessageService, DatePipe, CurrencyPipe]
})

export class PesquisaClickComponent implements OnInit {

    filterCedente: FilterCedente = {};
    cedentes: Cedente[];
    cedente: Cedente;
    historicoEmail: HistoricoEmailDisplay[];
    historicoClick: HistoricoClickDisplay[];
    historicoClickDetalhe: boolean;
    cols: any[];
    selectedCedente: Cedente[];
    filteredCedentes: Cedente[];
    selectedCedentesAdvanced: Cedente[];
    header: any[];
    perfil: Perfil;
    currentUsuario: Usuario;
    pesquisarClick: string;
    pesquisandoProgress: boolean;

   constructor(private messageService: MessageService, private breadcrumbService: AppBreadcrumbService,
               private cedenteService: CedenteService, private emailSacadoService: EmailSacadoService,
               private clickService: ClickService, private datepipe: DatePipe, private currencyPipe: CurrencyPipe,
               private authenticationService: AuthenticationService, private bscobrancaTranslate: BscobrancaTranslate) {
        this.pesquisarClick = this.bscobrancaTranslate.getText('menu.pesquisarClick');
        this.breadcrumbService.setItems([
                { label: this.pesquisarClick, routerLink: ['/titulo/pesquisaclick'] }
            ]);

        this.cols = [
                { field: 'nmeCedente', header: 'Cedente' },
                { field: 'nmeSacado', header: 'Nome Sacado' },
                { field: 'dtaLink', header: 'Data do Envio do Link' },
                { field: 'qtdeClick', header: 'Quantidades de clicks' },
                { field: 'emailSacado', header: 'E-mail Sacado' }
            ];
        this.header = ['Cedente', 'Nome Sacado', 'E-mail Sacado', 'Data do Envio do Link', 'Quantidade de Click', 'Nosso Numero', 'Valor Titulo'];
   }

    ngOnInit(): void {
        this.currentUsuario = this.authenticationService.atualUserValue;
        this.perfil = this.authenticationService.atualUserPerfilValue;
        this.cedente = {};
        this.cedenteService.getCedentesPorEmpresa(-1).subscribe(ceds => {
                this.cedentes = Array.from(ceds);
            });
    }

    limparFormulario(): void {
        this.filterCedente = {};
        this.cedente = {};
        this.historicoEmail = [];
        this.historicoClick = [];
    }

    pesquisarHistoricoClick(idHistoricoEmail: number): void {
        this.pesquisandoProgress = true;
        this.clickService.getHistoricoClick(idHistoricoEmail)
                .subscribe(
                    result => {
                        this.historicoClick = result;
                    } ,
                    err => console.log(err),
                    () => {
                    this.pesquisandoProgress = false;
            });
        this.historicoClickDetalhe = true;
     }

     hideDetalhesHistoricoClickDialog() {
        this.historicoClickDetalhe = false;
     }

     pesquisarClickTitulo(): void {
        if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT') {
            this.filterCedente.cedente = this.cedente;
        } else {
            this.filterCedente.cedente = {};
            this.filterCedente.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
        }
        this.pesquisandoProgress = true;
        this.emailSacadoService.getHistoricoEmail(this.filterCedente)
                .subscribe(
                    result => {this.historicoEmail = result; } ,
                    err => console.log(err),
                    () => {
                    this.pesquisandoProgress = false;
            });
     }

    numberOnly(event: { which: any; keyCode: any; }): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    filterCedentes(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.cedentes.length; i++) {
            const cedente = this.cedentes[i];
            if (cedente.nmeCedente.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(cedente);
            }
        }

        this.filteredCedentes = filtered;
    }

     downloadFile(filename= 'data') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
     }

     ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         // tslint:disable-next-line: forin
         for (const index in headerList) {
             row += headerList[index] + ';';
         }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.historicoEmail.length; i++) {
             const tit = this.historicoEmail[i];
             let line = (i + 1) + ';';
             line += tit.nomeCedente + ';';
             line += tit.nomeSacado + ';';
             line += tit.emailSacado + ';';
             // tslint:disable-next-line: radix
             line += this.datepipe.transform(tit.dtaEnvioLink, 'dd/MM/yyyy') + ';';
             line += tit.qtdeClicks + ';';
             line += tit.nossoNumero + ';';
             line += this.currencyPipe.transform(tit.vlrTitulo, 'BRL') + ';';
             str += line + '\r\n';
         }
         return str;
     }

    exportOptions = [
        {label: 'PDF', icon: 'pi pi-file-pdf', command: (x) => this.exportarConsultaClick('PDF') },
        {label: 'XLS', icon: 'pi pi-file-excel', command: (x) => this.exportarConsultaClick('XLSX')}
    ];

    exportarConsultaClick(formato: string) {
        if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT') {
            this.filterCedente.cedente = this.cedente;
        } else {
            this.filterCedente.cedente = {};
            this.filterCedente.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
        }
        this.filterCedente.formatoRelatorio = formato;
        this.emailSacadoService.exportarRelatorioClicks(this.filterCedente).subscribe((res: any) => {
            const file = new Blob([res], {
                type: res.type,

            });
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Clicks.` + formato;
            link.click();
            window.URL.revokeObjectURL(url);
            link.remove();
        });
    }

}
